export default __webpack_public_path__ + "svg/calendar/2026/0/febrero.svg?7466010c";